module.exports = __webpack_public_path__ + "img/ring_y_i_null_0@2x.9e84ffba.png";